import { Component, OnInit, ViewEncapsulation, HostListener, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';
import { CommandCenterService } from '../../../services/command-center/command-center.service';
import * as $ from 'jquery';
import { LoaderService } from '../../../services/infrastructure/loader.service';

@Component({
  selector: 'app-command-center',
  templateUrl: './cc-landing.component.html',
  styleUrls: ['./cc-landing.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CommandCenterComponent implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setMessageHeight();
    this.setinnerHeight();
  }

  //Array variables
  transitdisplayedColumns: string[] = ['orderNumber', 'Product', 'Vendor', 'shipToLocation', 'shippedQty', 'UOM', 'status', 'tracking'];
  recentdisplayedColumns: string[] = ['orderNumber', 'customerPo', 'orderDate', 'itemDescription', 'marketingBrand', 'shipToLocation', 'orderedQty', 'deliveredQty', 'status', 'tracking'];
  messageCenterMessages: any[] = [];
  knowledgeCenterMessages: any[] = [];
  unPinnedMessages: any[];
  pinnedMessages: any[];
  knowledgeIntialLoadData: any[];
  subscription = new Array<Subscription>();

  //Boolean variables
  showMessageCenterFullView: boolean = false;
  showKnowledgeCenterFullView: boolean = false;
  isMessageDataLoad: boolean = false;
  isKnowledgeDataLoad: boolean = false;
  isOTIDataLoad: boolean = false;

  // Date variables
  currentDate = new Date();

  //String variables
  formattedDate: string;
  pdfIcon = "../../../../assets/icon/svg/knw_pdf_icon.svg";
  vedioIcon = "../../../../assets/icon/svg/knw_vedio_icon.svg";
  imageIcon = "../../../../assets/icon/svg/knw_image_icon.svg";
  defaultIcon = "../../../../assets/icon/svg/knw_default_icon.svg";
  searchKeyword: string;
  initialLoadKeyword: string = 'Evolve';

  interval: any;

  constructor(  
    private commandCenterService: CommandCenterService,
    private loaderService: LoaderService)
  {
    this.formattedDate = this.getFormattedHeaderDate(this.currentDate);
  }

  ngOnInit(): void {
    this.loaderService.setLoaderStatus(true);
    this.getMessageCenterData();
    this.getKnowledgeCenterData(this.initialLoadKeyword, true);
    this.interval = setInterval(() => { this.stopLoader() }, 1000);
  }

  toggleHideShowMessageCenter() {
    this.showMessageCenterFullView = !this.showMessageCenterFullView;
  }

  showFullMessageCenter() {
    this.toggleHideShowMessageCenter();
  }

  showFullKnowledgeCenter() {
    this.toggleHideShowKnowledgeCenter();
  }

  toggleHideShowKnowledgeCenter() {
    this.showKnowledgeCenterFullView = !this.showKnowledgeCenterFullView;
  }

  backToHome() {
    this.toggleHideShowMessageCenter();
  }

  backToHomeFrmKnow() {
    this.searchKeyword = '';
    this.knowledgeCenterMessages = this.knowledgeIntialLoadData;
    this.toggleHideShowKnowledgeCenter();
    this.setMessageHeight();
    this.setinnerHeight();
  }

  backToMainFromKnowledgeHome() {
    this.toggleHideShowKnowledgeCenter();
  }

  ngAfterViewInit() {
    this.setMessageHeight();
    this.setinnerHeight();
  }

  setMessageHeight() {
    const templateNewHeight = window.innerHeight - $('.messageCenter').outerHeight() - 120;

    $('.knowledgeCenter').css('max-height', templateNewHeight + 'px');


    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.knowledgeCenter').outerHeight() - 160;
      $('.messageCenter').css('max-height', templateHeight + 'px');
      $('.messageCenter').css('min-height', templateHeight + 'px');


    }, 500);

  }

  setinnerHeight() {
    const templateaccordSecHeight = window.innerHeight - $('.knowledgeCenter').outerHeight() - 295;
    $('.accordSec').css('min-height', templateaccordSecHeight + 'px');
  }

  searchKnowledge() {
    this.loaderService.setLoaderStatus(true);
    this.isKnowledgeDataLoad = false;
    this.getKnowledgeCenterData(this.searchKeyword)
  }

  searchChildComp(searchKeyword) {
    this.loaderService.setLoaderStatus(true);
    this.isKnowledgeDataLoad = false;
    this.getKnowledgeCenterData(searchKeyword)

  }

  getMessageCenterData() {
    this.subscription.push(
      this.commandCenterService.getMessageCenterData().subscribe(
        (result: any[]) => {
          this.messageCenterMessages = result;
          this.messageCenterMessages.sort((a, b) => {
            if (a.isPinned === b.isPinned) {
              return b.updateTimestamp - a.updateTimestamp;
            }
            return a.isPinned === true ? -1 : 1;
          });
          this.isMessageDataLoad = true;
        },
        error => {
          this.isMessageDataLoad = true;
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
    this.setMessageHeight();
  }

  getKnowledgeCenterData(keyword: string, isIntialLoad: boolean = false) {
    this.isKnowledgeDataLoad = false;
    this.subscription.push(
      this.commandCenterService.getKnowledgeCenterData(keyword).subscribe(
        (result: any[]) => {

          this.knowledgeCenterMessages = result;
          this.knowledgeCenterMessages.forEach(x => {
            x.iconUrl = this.GetKnowledgeIconSource(x.documentType);
          });

          if (isIntialLoad) {
            this.knowledgeIntialLoadData = this.knowledgeCenterMessages;
          }
          this.isKnowledgeDataLoad = true;
          if (!isIntialLoad)
          this.loaderService.setLoaderStatus(false);
        },
        error => {
          this.isKnowledgeDataLoad = true;
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
    this.setMessageHeight();
  }

  getFormattedHeaderDate(date: Date): string {
    const dateFormat = new Date(date); // CST (UTC-6)
    let formattedDate = dateFormat.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: 'America/Chicago'
    }) + ' CST';

    return formattedDate.replace(/at/gi, "   ").toUpperCase();
  }

  getFormattedMessageDate(date: Date): string {
    const dateFormat = new Date(date); // CST (UTC-6)
    let formattedDate = dateFormat.toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/Chicago'
    });
    return formattedDate.replace(/at/gi, "").replace(/,/g, "").toUpperCase();
  }

  messagePinOnChildComp(values: { messageObj: any; isPin: boolean }) {
    this.pinUnPinMessage(values.messageObj, values.isPin)
  }

  pinUnPinMessage(message, isPin) {
    this.subscription.push(this.commandCenterService.pinMessage({ messageId: message.messageId, pinnedMessage: isPin }).subscribe((result: any) => {
      if (result) {
        message.isPinned = isPin;
        this.messageCenterMessages.sort((a, b) => {
          if (a.isPinned === b.isPinned) {
            return b.updateTimestamp - a.updateTimestamp;
          }
          return a.isPinned === true ? -1 : 1;
        });
      }
    },
      error => {
        LolLoggerService.error(error);
      }));
  }

  readMessage(message) {
    if (!message.isRead) {
      this.subscription.push(this.commandCenterService.readMessage({ messageId: message.messageId }).subscribe((result: any) => {
        if (result) {
          message.isRead = true;
        }
      },
        error => {
          LolLoggerService.error(error);
        }));
    }
  }

  otiDataLoad(isLoad: boolean) {
    this.isOTIDataLoad = isLoad;
  }

  stopLoader() {
    if (this.isMessageDataLoad && this.isOTIDataLoad && this.isKnowledgeDataLoad) {
      this.loaderService.setLoaderStatus(false);
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  openUrl(url) {
    window.open(url, '_blank');
  }

  GetKnowledgeIconSource(documentType) {
    let imageSrc = "";
    switch (documentType) {
      case "application/pdf": imageSrc = this.pdfIcon;
        break;
      case "video/x-msvideo": imageSrc = this.vedioIcon;
        break;
      case "image/png": imageSrc = this.imageIcon;
        break;
      default: imageSrc = this.defaultIcon;
        break;

    }
    return imageSrc;

  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
